import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { panelPath } from "../auth/session";
import Home from "../layout/Home/Home";
import AdminRouter from "./AdminRouter";
import UserRouter from "./UserRouter";
import NotFoundPage from "./NotFoundPage";

export default function Router() {
  const { session } = useAuth();
  const role = session?.user.role;
  const redirect = <Navigate to={panelPath(session)} replace />;
  return <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/admin/*" element={["staff", "superuser"].includes(role) ? <AdminRouter /> : redirect} />
    <Route path="/dashboard/*" element={role === "student" ? <UserRouter /> : redirect} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>;
}
